<template>
    <div 
        class="it"
        @click="toggleTooltip"
        @keydown.enter.space="toggleTooltip"
        @keydown.esc="closeTooltip"
        ref="infotooltip"
        tabindex="0"
        role="button"
        :aria-expanded="showTooltip.toString()"
        :aria-haspopup="'true'"
    >
        <img
            class="it__icon"
            :src="iconSrc"
            alt="Info"
            tabindex="-1"
            aria-hidden="true"
        />
        <div v-if="showTooltip" class="it-content" :class="orientation" role="tooltip">
            <p v-for="(item, index) in items" :key="index">
                <span v-text="$ml.get(item)" />
                <br v-if="index !== items.length - 1" />
                <br v-if="index !== items.length - 1" />
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        orientation: {
            type: String,
            default: 'top',
            validator: (value) => ['top', 'bottom', 'left', 'right'].includes(value)
        },
        items: {
            type: Array,
            default: () => []
        },
        iconColor: {
            type: String,
            default: 'blue',
            validator: (value) => ['blue', 'gray'].includes(value)
        }
    },
    data() {
        return {
            showTooltip: false
        };
    },
    computed: {
        iconSrc() {
            // Adapte os nomes dos arquivos conforme necessário
            if (this.iconColor === 'blue') {
                return require('@/assets/img/icons/info-blue.svg');
            } else if (this.iconColor === 'gray') {
                return require('@/assets/img/icons/info-gray.svg');
            }

            return require(`@/assets/img/icons/info-blue.svg`);
        }
    },
    methods: {
        toggleTooltip() {
            this.showTooltip = !this.showTooltip;
            if (this.showTooltip) {
                this.$nextTick(() => {
                    // Move o foco para o tooltip para acessibilidade
                    const tooltip = this.$el.querySelector('.it-content');
                    if (tooltip) tooltip.focus();
                });
            }
        },
        closeTooltip() {
            this.showTooltip = false;
        },
        handleClickOutside(event) {
            if (this.showTooltip && !this.$refs.infotooltip.contains(event.target)) {
                this.showTooltip = false;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    }
};
</script>

<style lang="scss" scoped>
    .it {
        position: relative;
        display: inline-block;
        cursor: pointer;
        outline: none;
        &:focus {
            outline: 2px solid #1976d2;
            outline-offset: 2px;
        }
    }

    .it-content {
        position: absolute;
        background-color: #1E1E1E;
        border-radius: 8px;
        padding: 12px;
        font-size: 12px;
        line-height: normal;
        color: #FFFFFF;
        z-index: 1;
        width: 276px;
        outline: none;
        &:focus {
            outline: 2px solid #1976d2;
            outline-offset: 2px;
        }

        &::before {
            content: '';
            position: absolute;
            border-width: 8px;
            border-style: solid;
        }

        &.top {
            bottom: 100%;
            left: 50%;
            transform: translate(-50%, -14px);

            &::before {
                top: 100%;
                left: 50%;
                transform: translateX(-50%);
                border-color: #1E1E1E transparent transparent transparent
            }
        }

        &.bottom {
            top: 100%;
            left: 50%;
            transform: translate(-50%, 14px);

            &::before {
                bottom: 100%;
                left: 50%;
                transform: translateX(-50%);
                border-color: transparent transparent #1E1E1E transparent
            }
        }

        &.left {
            top: 50%;
            right: 100%;
            transform: translate(-14px, -50%);

            &::before {
                top: 50%;
                left: 100%;
                transform: translateY(-50%);
                border-color: transparent transparent transparent #1E1E1E
            }
        }

        &.right {
            top: 50%;
            left: 100%;
            transform: translate(14px, -50%);

            &::before {
                top: 50%;
                right: 100%;
                transform: translateY(-50%);
                border-color: transparent #1E1E1E transparent transparent
            }
        }

        p {
            margin: 0;
        }
    }
</style>